import { useNavigate } from 'react-router-dom';
import { Users, Camera, Clock, Image, AlertTriangle, FileText, ChevronRight } from 'lucide-react';
import { Card, Button } from '@components/ui';
import clsx from 'clsx';

/**
 * Bugünkü Operasyon Özeti
 * Puantaj + Şantiye Günlüğü — kompakt ve bilgilendirici
 */
export default function OperasyonOzeti({ puantajStats, gunlukStats }) {
    const navigate = useNavigate();

    return (
        <div>
            <h2 className="text-base font-semibold text-text-primary mb-3">Bugünkü Operasyon</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Puantaj Kartı */}
                <Card padding="none" className="overflow-hidden">
                    <div className="flex items-center justify-between px-4 pt-4 pb-2">
                        <div className="flex items-center gap-2">
                            <div className="w-8 h-8 rounded-lg bg-secondary/10 flex items-center justify-center">
                                <Users size={16} className="text-secondary" />
                            </div>
                            <h3 className="font-semibold text-sm text-text-primary">Personel Durumu</h3>
                        </div>
                        <Button variant="ghost" size="sm" onClick={() => navigate('/insaat/personel')}>
                            Detay <ChevronRight size={14} />
                        </Button>
                    </div>

                    {puantajStats.calisanSayisi > 0 || puantajStats.izinliSayisi > 0 ? (
                        <div className="px-4 pb-4">
                            <div className="grid grid-cols-3 gap-3">
                                <MetrikKutu
                                    deger={puantajStats.calisanSayisi}
                                    etiket="Çalışan"
                                    renk="success"
                                />
                                <MetrikKutu
                                    deger={`${puantajStats.fazlaMesaiSaat.toFixed(1)}h`}
                                    etiket="Mesai"
                                    renk="warning"
                                />
                                <MetrikKutu
                                    deger={puantajStats.izinliSayisi}
                                    etiket="İzinli"
                                    renk="info"
                                />
                            </div>
                        </div>
                    ) : (
                        <div className="px-4 pb-4">
                            <div className="flex items-center gap-3 p-3 rounded-lg bg-bg-tertiary/50 border border-border-light">
                                <Clock size={18} className="text-text-muted shrink-0" />
                                <div>
                                    <p className="text-sm text-text-secondary">Henüz bugünkü puantaj girilmedi</p>
                                    <p className="text-xs text-text-muted mt-0.5">Personel & Yoklama sayfasından giriş yapabilirsiniz</p>
                                </div>
                            </div>
                        </div>
                    )}
                </Card>

                {/* Şantiye Günlüğü Kartı */}
                <Card padding="none" className="overflow-hidden">
                    <div className="flex items-center justify-between px-4 pt-4 pb-2">
                        <div className="flex items-center gap-2">
                            <div className="w-8 h-8 rounded-lg bg-info/10 flex items-center justify-center">
                                <Camera size={16} className="text-info" />
                            </div>
                            <h3 className="font-semibold text-sm text-text-primary">Şantiye Günlüğü</h3>
                        </div>
                        <Button variant="ghost" size="sm" onClick={() => navigate('/insaat/gunluk')}>
                            Detay <ChevronRight size={14} />
                        </Button>
                    </div>

                    <div className="px-4 pb-4">
                        <div className="grid grid-cols-3 gap-3">
                            <MetrikKutu
                                deger={gunlukStats.toplamKayit}
                                etiket="Kayıt"
                                renk="primary"
                            />
                            <MetrikKutu
                                deger={gunlukStats.fotografSayisi}
                                etiket="Fotoğraf"
                                renk="secondary"
                            />
                            <MetrikKutu
                                deger={gunlukStats.sorunluGunler}
                                etiket="Sorunlu Gün"
                                renk={gunlukStats.sorunluGunler > 0 ? 'warning' : 'success'}
                            />
                        </div>
                    </div>
                </Card>
            </div>
        </div>
    );
}

// Mini metrik kutusu
function MetrikKutu({ deger, etiket, renk }) {
    return (
        <div className={clsx('rounded-lg p-2.5 text-center', `bg-${renk}/10`)}>
            <p className={clsx('text-xl font-bold', `text-${renk}`)}>{deger}</p>
            <p className="text-2xs text-text-muted mt-0.5">{etiket}</p>
        </div>
    );
}
